<div class="detail">
  <div class="detail__header">
    <div class="detail__breadcrumb">
      <button type="button" class="detail__breadcrumb-link" (click)="goBack()">Organisations</button>
      <mat-icon>chevron_right</mat-icon>
      <span class="detail__breadcrumb-current">{{ partyNameValue || '' }}</span>
    </div>

    <div class="detail__title-row">
      <h2>{{ partyNameValue || '' }}</h2>
      @if (partyNumberValue) {
        <span class="detail__badge">Customer no. {{ partyNumberValue }}</span>
      }
      <span class="detail__count">{{ people.length }} people · {{ departments.length }} departments</span>

      @if (dirty) {
        <span class="detail__badge detail__badge--dirty"><mat-icon>circle</mat-icon>Unsaved changes</span>
      }
      @if (isNew) {
        <span class="detail__badge detail__badge--new">New — not listed until it has a contact</span>
      }

      <span class="detail__spacer"></span>
      <span class="detail__drag-hint"><mat-icon>drag_indicator</mat-icon>Drag to set the order customers see</span>
    </div>
  </div>

  @if (loading) {
    <div class="detail__spinner"><mat-spinner diameter="48"></mat-spinner></div>
  } @else if (hasError) {
    <p class="detail__error">Could not load this organisation. Please go back and try again.</p>
  } @else {
    <div class="detail__body">
      <div class="detail__columns">
        <div class="detail__left">
          <app-people-section
            [people]="people"
            [contacts]="contacts"
            [organisationParty]="organisationParty"
            [autoOpenAdd]="isNew"
            (add)="addPerson($event)"
            (remove)="removePerson($event)"
            (reorder)="reorderPeople($event)"
            (update)="updatePerson($event.contactId, $event.patch)"></app-people-section>

          <app-departments-section
            [departments]="departments"
            [contacts]="contacts"
            [organisationParty]="organisationParty"
            [productsById]="productsById"
            (add)="addDepartment($event)"
            (remove)="removeDepartment($event)"
            (reorder)="reorderDepartments($event)"></app-departments-section>
        </div>

        <div class="detail__right">
          <app-customer-preview
            [partyName]="partyNameValue"
            [people]="people"
            [departments]="departments"></app-customer-preview>
        </div>
      </div>
    </div>

    <div class="detail__footer">
      <span class="detail__save-hint">{{ dirty ? 'You have unsaved changes.' : 'No pending changes.' }}</span>
      <span class="detail__spacer"></span>
      <button type="button" class="m-btn m-btn-secondary" [disabled]="!dirty || saving" (click)="discard()">
        Discard changes
      </button>
      <button type="button" class="m-btn m-btn-primary" [disabled]="!dirty || saving" (click)="save()">
        {{ saving ? 'Saving...' : 'Save changes' }}
        <span class="sgl-arrows" aria-hidden="true"></span>
      </button>
    </div>
  }
</div>
